import { UseCase } from '@/core/base/use-case';
import { CarouselResponse } from '../models/carousel.model';
import { CarouselRepository } from '../repositories/carousel.repository';
import { Observable } from 'rxjs';

export class GetCarouselDataUseCase
    implements UseCase<never, CarouselResponse>
{
    constructor(private readonly repository: CarouselRepository) {}

    execute(): Observable<CarouselResponse> {
        return this.repository.getCarouselData();
    }
}
